module.exports = __webpack_public_path__ + "static/media/lmu_logo.8f2cf03e.jpg";